/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';

import {VisitorProfileFields} from '../../components/api/resources/resource/visitor-profile-fields';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-fields-route-page',
  template: `
    <p>The available fields to store data against.</p>
    <adn-promise-spinner [resolved]="fields">
      <table class="table table-hover table-bordered table-condensed" role="grid" *ngIf="fields?.length">
        <thead>
        <tr>
          <th>Field Name</th>
          <th>Data Type</th>
          <th>Group</th>
          <th>Description</th>
          <th>Example</th>
          <th>Aliases</th>
          <th>Transformations</th>
        </tr>
        </thead>
        <tbody>
        <tr role="row" *ngFor="let field of fields">
          <td>{{field.name}}</td>
          <td>{{field.type}}</td>
          <td>{{field.group}}</td>
          <td>{{field.description}}</td>
          <td>{{field.example}}</td>
          <td>{{field.aliasesJoined}}</td>
          <td>
            <div *ngFor="let entry of field.transformations | keyvalue">
              {{entry.key}} -> {{entry.value}}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </adn-promise-spinner>
  `
})
export class FieldsRoutePageComponent implements OnInit {
  fields: any[];

  constructor(
    private readonly visitorProfileFields: VisitorProfileFields,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.visitorProfileFields.get().then((fields: any[]) => {
      // undefined → [] flips [resolved] on adn-promise-spinner; defer to avoid NG0100.
      deferMarkForCheck(this.cdr, () => {
        this.fields = (fields || []).map((field: any) => ({
          ...field,
          aliasesJoined: ((field && field.aliases) || []).join(', ')
        }));
      });
    });
  }
}

